module.exports = __webpack_public_path__ + "static/media/fasad12.b2088876.jpeg";